// src/components/Topbar/Topbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AiOutlineLogout,
  AiOutlineUser,
  AiOutlineBell,
  AiFillBell
} from 'react-icons/ai';
import tokenMonitor from '../../utils/tokenMonitor';
import { useNotification } from '../../context/NotificationContext';
import './Topbar.css';

function Topbar() {
  const navigate = useNavigate();
  const { enabled, toggleNotifications } = useNotification();

  const handleLogout = async () => {
    // 토큰 모니터링 중지
    tokenMonitor.stopMonitoring();

    // 서버에 로그아웃 요청 (httpOnly 쿠키 삭제)
    try {
      const apiClient = (await import('../../utils/axiosInstance')).default;
      await apiClient.post('/auth/logout');
    } catch {
      // 로그아웃 API 실패해도 계속 진행
    }
    localStorage.removeItem('csrf_token');

    // 로그인 페이지로 리다이렉트
    navigate('/admin/login');
  };

  return (
    <nav className="topbar">
      <div className="topbar-brand">
        <Link to="/admin" className="brand-link">
          TransBridge
        </Link>
      </div>

      <div className="topbar-right">
        <button
          className={`notification-toggle ${enabled ? 'active' : ''}`}
          onClick={toggleNotifications}
          title={enabled ? '주문 알림 끄기' : '주문 알림 켜기'}
        >
          {enabled ? <AiFillBell size={20} /> : <AiOutlineBell size={20} />}
        </button>
        <div className="profile-section">
          <AiOutlineUser size={20} />
          <button 
            className="logout-button"
            onClick={handleLogout}
          >
            <AiOutlineLogout size={18} />
            <span>로그아웃</span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Topbar;
